
import React, {useContext, useState} from 'react';
import {OrderContext} from 'views/order/OrderForm';
import AppUtil from 'AppUtil';
import AppConstants from 'AppConstants';
import {Button} from 'views/AppElements';
import {ComboBox, Input} from 'views/FormElements';
import Modal from 'react-responsive-modal';

const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;

//include quanity per size
const BulkOrderInput = ({sizeOptions, openModal, setOpenModal}) => {
    const {setBulkOrderFormType, setFieldValue, values} = useContext(OrderContext);
    const [sizeQuantity, setSizeQuantity] = useState(values.sizeQuantity);
    const [errorMessage, setErrorMessage] = useState('');

    const onClose = () => {
        setOpenModal(false);
    };

    const applyBulkOrder = () => {
        const totalSum = Object.values(sizeQuantity).reduce((a, b) => parseInt(a) + parseInt(b), 0)
        
        if(totalSum < AppConstants.BULK_MINMUM_QUANTITY) {
            setErrorMessage("Please provide at least "+AppConstants.BULK_MINMUM_QUANTITY+" quantities.");
        } else {
            setBulkOrderFormType(true);
            setOpenModal(false);
            setFieldValue('sizeQuantity', sizeQuantity);
        }
    };

    const cancelBulkOrder = () => {
        setBulkOrderFormType(false);
        setOpenModal(false);
    };

    var quantities = sizeOptions.map((s) => {
        return <div className="mui-textfield" key={"bulk_order_"+s.value}>
                <label>{s.label}</label>
                <input type="number" value={sizeQuantity[s.value] || ''} onChange={(e) => {
                    sizeQuantity[s.value] = e.target.value;
                    setSizeQuantity({...sizeQuantity});
                    setErrorMessage('');
                }}/>
                </div>;
    });

    return <Modal closeOnOverlayClick={false} open={openModal} 
            onClose={onClose} 
            classNames={{ modal: 'bulk-order-modal', closeIcon: 'bulk-order-close-icon' }}>
                <div>
                    <h2 style={{margin: '0 0 20px 0'}}>Bulk Order Quantities</h2>
                    <div className="highlightInfo">
                        <i className="fa fa-exclamation-circle" aria-hidden="true" /> Receive {AppConstants.BULK_ORDER_DISCOUNT_PCT * 100.0}% discount with minimum of {AppConstants.BULK_MINMUM_QUANTITY} orders.
                    </div>
                    {quantities}

                    {errorMessage && 
                    <div className="errorMessage">
                        {errorMessage}
                    </div>}
                    
                    <div className="flexRow" style={{justifyContent: 'space-between'}}>
                        <Button mui='true' color='primary' onClick={applyBulkOrder}>Submit</Button>

                        {
                            values.isBulkOrderForm === true &&
                            <Button mui='true' color='danger' onClick={cancelBulkOrder}>Cancel Bulk Order</Button>
                        }
                        
                    </div>
                </div>
        </Modal>
};


const OrderSizeInput = () => {
    const {product, values, productSizes, setBulkOrderFormType} = useContext(OrderContext);
    const [openBulkOrderModal, setOpenBulkOrderModal] = useState(false);
    const isBulkOrderForm = values.isBulkOrderForm;
    const isCoupleProduct = AppUtil.isCoupleProduct(product);
    const isSizeProvided = values.productSize || (values.maleSize && values.femaleSize);

    const sizeOptions = AppUtil.getProductSizeOptions(product);

    const isOutofStock = product.outofStock;

    let hasPricePerSize = false;
    Object.keys(productSizes).forEach(s => {
        if(productSizes[s].priceAddition > 0)
            hasPricePerSize = true;
    });


    if(hasPricePerSize) {
        sizeOptions.forEach(s => {
            const pricePerSize = product.price + productSizes[s.value].priceAddition;
            s.label = s.label +" - Rs. "+AppUtil.formatNumber(pricePerSize);
        });
    }

    
    return <React.Fragment>
            {isCoupleProduct === true &&
                <div>
                    <ComboBox label="Male Size: " name="maleSize" value={values.maleSize} 
                            options={sizeOptions} placeholder="Select Male Size" />

                    <ComboBox label="Female Size: " name="femaleSize" value={values.femaleSize} 
                            options={sizeOptions} placeholder="Select Female Size" />
                </div>
            }

            {isCoupleProduct === false &&

                <div>
                    {
                        !isBulkOrderForm &&
                        <div>
                            <ComboBox name="productSize" value={values.productSize} 
                                options={sizeOptions} placeholder="Select Size" />

                            <div className="mui-btn mui-btn--primary mui-btn--flat mui-btn--small"  style={{marginLeft: 'auto', display: 'block', width: 'fit-content'}}>
                                <span onClick={() => {
                                    setOpenBulkOrderModal(true);
                                }}><i className='fa fa-opencart'></i> Buy in Bulk</span>
                            </div>
                        </div>
                    }
                    

                    <BulkOrderInput sizeOptions={sizeOptions} 
                                            openModal={openBulkOrderModal} 
                                            setOpenModal={setOpenBulkOrderModal} />

                    {
                        isBulkOrderForm && 
                        <React.Fragment>
                            <div className='mui-textfield' style={{marginBottom: '5px'}}><label>Bulk Quantities:</label></div>

                            <div className="flexRow">
                            {
                                sizeOptions.map(s => {
                                    const label = s.label;
                                    const quantity = values.sizeQuantity[s.value];
                                    if(!quantity) return null;

                                    return <Button mui="true" size="small" variant="flat" key={"bulkOrder-"+s.value}>{label} : {quantity}</Button>
                                })
                            }
                            </div>

                            
                            <div className="flexColumn">
                                <Button mui="true" size="small" color="primary" onClick={() => setOpenBulkOrderModal(true)}>
                                    <i className="fa fa-pencil" aria-hidden="true"></i> Edit Bulk Quantities
                                </Button>
                            </div>
                        </React.Fragment>
                    }

                    {product.productType === PRODUCT_TYPES.PHOTO_FRAME.val && !isSizeProvided &&
                    <div style={{marginBottom: '10px', color: 'gray'}}>
                        <span><i className="fa fa-exclamation-circle" aria-hidden="true"></i> To order frames with sizes not listed above, please </span>
                        <a target="_blank" href="https://m.me/setocanvascom">DM US</a> 
                    </div>
                    }	

                    
                    
                </div>
            }
            {
                isOutofStock === true &&
                <span style={{color: 'red', fontWeight: 'bold', fontSize: '1.1em'}}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Out of Stock</span>
            }
        </React.Fragment>
};

export default OrderSizeInput;


// WEBPACK FOOTER //
// ./src/views/order/input/OrderSizeInput.js